import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { SalesforceAuthTypes, SalesforceV2LinkedService } from 'shell-models-lib';
import { parameterizablePasswordOrAKVtoSecretBase, parameterizableSecretBaseToModel } from './azure-key-vault.util';
import { ValueAdapter } from '../value.adapter';
import { isLogicAppExpression } from 'app/shared/utils/expression.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SalesforceV2LinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                environmentUrl: '*',
                clientId: '*',
                clientSecret: 'secret',
                encryptedCredential: '*',
                authenticationType: '*',
                apiVersion: '*'
            },
            parameters: '*'
        }
    }
})
export class SalesforceV2LinkedServiceAdapter extends LinkedServiceAdapter<SalesforceV2LinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => SalesforceV2LinkedService {
        return SalesforceV2LinkedService;
    }

    protected model(): IModel {
        return SalesforceV2LinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: SalesforceV2LinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.SalesforceV2LinkedService;

        const environmentUrl = this.valueToResource(linkedService, SalesforceV2LinkedService.ENVIRONMENT_URL);
        const apiVersion = this.valueToResource(linkedService, SalesforceV2LinkedService.API_VERSION);
        const clientId = this.valueToResource(linkedService, SalesforceV2LinkedService.CLIENT_ID);
        const clientSecret = parameterizablePasswordOrAKVtoSecretBase(linkedService, SalesforceV2LinkedService.CLIENT_SECRET, this.context);
        const authenticationType = linkedService.authenticationType || SalesforceAuthTypes.OAuth;

        properties.type = Metamodel.modelOf(linkedService).name;
        properties.typeProperties = {
            environmentUrl,
            clientId,
            clientSecret,
            apiVersion,
            authenticationType
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: SalesforceV2LinkedService): Promise<SalesforceV2LinkedService> {
        const properties = linkedServiceResource.properties as Model.SalesforceV2LinkedService;
        const typeProperties = properties.typeProperties;
        ValueAdapter.toModel(
            linkedService,
            SalesforceV2LinkedService.ENVIRONMENT_URL,
            typeProperties.environmentUrl
                ? isLogicAppExpression(typeProperties.environmentUrl) || typeof typeProperties.environmentUrl !== 'string'
                    ? typeProperties.environmentUrl
                    : typeProperties.environmentUrl.toLowerCase()
                : 'https://login.salesforce.com'
        );
        ValueAdapter.toModel(linkedService, SalesforceV2LinkedService.CLIENT_ID, typeProperties.clientId);
        parameterizableSecretBaseToModel(linkedService, SalesforceV2LinkedService.CLIENT_SECRET, typeProperties.clientSecret, this.context);
        ValueAdapter.toModel(linkedService, SalesforceV2LinkedService.API_VERSION, typeProperties.apiVersion);
        linkedService.authenticationType = typeProperties.authenticationType || SalesforceAuthTypes.OAuth;

        return linkedService;
    }
}
